import React, {useState, useEffect} from 'react';
import UserInfo from '../../Components/User/UserInfo';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import MonthProfit from './components/MonthProfit';
import LevelsList from './components/LevelsList.new';
import {monthNow} from '../../assets/utils/dateUtils';
import Calendar from 'react-calendar';
import s from '../../Components/Calendar/MyCalendar.module.css';
import styles from './Receipt.module.css';
import {useTranslation} from 'react-i18next';
import TopPageInfoBlock from '../../Components/TopPageInfoBlock/TopPageInfoBlock';
import {useClickOutside} from '../../hooks/useClickOutside';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';
import {useSearchParams} from 'react-router-dom';

const Receipt: React.FC = () => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();
	const [searchParams] = useSearchParams();
	const monthFromUrl = searchParams.get('month');
	const [currentMonth, setCurrentMonth] = useState<string>(
		monthFromUrl || monthNow(),
	);
	const [openCalendar, setOpenCalendar] = useState<boolean>(false);

	useEffect(() => {
		if (monthFromUrl) {
			setCurrentMonth(monthFromUrl);
		}
	}, [monthFromUrl]);

	const handleChangeMonth = (value: any) => {
		// Получаем первое число выбранного месяца без сдвигов
		const dateObject = new Date(value);
		const year = dateObject.getFullYear();
		const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
		const formattedMonth = `${year}-${month}-01`;
		setCurrentMonth(formattedMonth);
		setOpenCalendar(false);
	};
	const handleCalendar = () => {
		setOpenCalendar(!openCalendar);
	};
	const handleCloseCalendar = () => {
		setOpenCalendar(false);
	};
	const calendarRef = useClickOutside<HTMLDivElement>(handleCloseCalendar);

	if (!restrictions.canAccessNetworkIncomePage) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	return (
		<div className="page__content">
			<TopTitleBlock title={t('Мій дохід з мережі')} />
			<div className="page__user user">
				<div className="user__row">
					<div className="user__column">
						<UserInfo />
					</div>
					<div className="user__column" style={{position: 'relative'}}>
						<MonthProfit month={currentMonth} handleCalendar={handleCalendar} />
						{openCalendar && (
							<div ref={calendarRef} className={styles.calendarPopup}>
								<div className={s.title}>{t('Оберіть місяць')}</div>
								<Calendar
									view="year"
									maxDetail="year"
									tileClassName={({date, view}) => {
										// Используем встроенную логику библиотеки для определения активного месяца
										const currentDate = new Date(currentMonth);
										const isCurrentMonth =
											date.getFullYear() === currentDate.getFullYear() &&
											date.getMonth() === currentDate.getMonth();
										return isCurrentMonth ? s.calendarTileActive : '';
									}}
									className={s.calendarContainer}
									onChange={handleChangeMonth}
									value={currentMonth}
									formatMonthYear={(locale, date) => {
										// Кастомное форматирование месяцев
										const months = [
											t('Січень'),
											t('Лютий'),
											t('Березень'),
											t('Квітень'),
											t('Травень'),
											t('Червень'),
											t('Липень'),
											t('Серпень'),
											t('Вересень'),
											t('Жовтень'),
											t('Листопад'),
											t('Грудень'),
										];
										return months[date.getMonth()];
									}}
									formatYear={(locale, date) => date.getFullYear().toString()}
									prev2Label={null}
									next2Label={null}
									showNeighboringMonth={false}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
			{!restrictions.canShowReceiptIncome && (
				<StatusRestrictionMessage message={t("Тут з'явиться інформація коли ви зареєструєте клієнтів в свою мережу.")} />
			)}
			{restrictions.canShowReceiptIncome && (
				<>
					<TopPageInfoBlock
						text={t(
							'Мій дохід з мережі — це дохід від розвитку власної команди.',
						)}
						subText={t(
							'Коли у Вашій структурі з’являються активні партнери, які користуються продуктом і теж розвивають свій бізнес, компанія винагороджує Вас за цю роботу.\n' +
								'Ви отримуєте відсоток від товарообігу вашої команди — тобто від усіх покупок, які роблять партнери у Вашій мережі.\n' +
								'Чим більше людей користується продуктом і розвиває бізнес разом із Вами, тим вищий Ваш стабільний дохід. \n' +
								'Це системна виплата  зростає разом із вашою командою.',
						)}
					/>
					<LevelsList month={currentMonth} />
				</>
			)}
		</div>
	);
};

export default Receipt;
